// extracted by mini-css-extract-plugin
export default {"respons":"style_respons__5OyzW","media":"style_media__223F6"};